import { MetricBase, MetricWithSeries, Series, TrendMetric, defaultMetricBase, defaultMetricWithSeries, defaultSeries, defaultTrendMetric } from './metrics';

export interface AdminDashboard {
    monthlyClaims: MetricWithSeries<number>; 
    openClaimCount: MetricBase<number>; 
    openClaimsByCarrier: Series<number>; 
    assignQueue: MetricBase<number>; 
    ytdClaimsClosed: MetricBase<number>; 
    ytdClaimsOpened: TrendMetric<number>;
}

export const defaultAdminDashboard: AdminDashboard = {
    monthlyClaims: defaultMetricWithSeries, 
    openClaimCount: defaultMetricBase, 
    openClaimsByCarrier: defaultSeries,
    assignQueue: defaultMetricBase,
    ytdClaimsClosed: defaultMetricBase,
    ytdClaimsOpened: defaultTrendMetric
}
